<template>
  <OmtLayoutContainer>
    <OmtRow mb="16px">
      <OmtTypography as="h1-bold"> Laboratórios que realizam todos os exames cobertos </OmtTypography>
    </OmtRow>
    <OmtRow mb="24px">
      <OmtInput
        v-model="search"
        variant="filled"
        iconRight="search"
        placeholder="Busque pelo nome do laboratório"
        @keydown.enter.prevent="searchLaboratories"
      />
    </OmtRow>
    <OmtRow mb="24px">
      <SeeLabRulesPainel :address="address" :is-coverage-analysis="true" />
    </OmtRow>
    <template v-if="searchLabs.length > 0">
      <OmtRow v-for="(lab, index) in searchLabs" :key="'lab-item_' + index"
stack>
        <OmtDivider v-if="index !== 0" w="calc(100% - 32px) !important"
m="0 auto !important" />
        <LabItem
          :logo="'https://picsum.photos/24/24'"
          :name="lab.Nome"
          :address="lab.Endereco"
          :distance="labDistance(lab.Distancia)"
          :show-details-action="seeLab"
          :showDetailsAction="() => seeUnit(lab)"
        />
      </OmtRow>
    </template>
    <OmtRow v-else stack
mb="16px">
      <CFlex>
        <OmtIcons name="circle-exclamation" size="1x"
mr="8px" />
        <OmtTypography as="p1" color="var(--colors-light-primary-gray1)">
          Não localizamos laboratórios que atendam aos critérios acima.
        </OmtTypography>
      </CFlex>
    </OmtRow>
    <FixedButtonRow>
      <OmtButton :w="['100%', '308px !important']" @click="finish"> Concluir </OmtButton>
    </FixedButtonRow>
  </OmtLayoutContainer>
</template>
<script>
import FixedButtonRow from "@/components/Atoms/FixedButtonRow/index.vue";
import LabItem from "@/components/Molecules/LabItem/index.vue";
import SeeLabRulesPainel from "@/components/Molecules/SeeLabRulesPainel/index.vue";
import { debounce } from "lodash";
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  components: {
    LabItem,
    SeeLabRulesPainel,
    FixedButtonRow
  },
  data() {
    return {
      search: "",
      noResult: false
    };
  },
  watch: {
    search: function () {
      this.searchLaboratories();
    }
  },
  computed: {
    ...mapState("copay", ["address"]),
    ...mapState("coverageAnalysis", ["selectedExams", "searchLabs"]),
    address() {
      const infos = this.$store.state.copay.address?.infos || {};
      return { ...infos };
    },
    seeLab() {
      return null;
    }
  },
  methods: {
    ...mapActions("coverageAnalysis", ["fetchLaboratoriess"]),
    ...mapActions("copay", ["fetchBaseAddress"]),
    ...mapMutations("affiliate", ["SET_MATCH"]),
    searchLaboratories: debounce(async function () {
      this.$root.$emit("show-loading");
      const result = await this.fetchLaboratoriess({ prestador: this.search, idSimulacao: this.idSimulacao });

      this.noResult = result === "";

      this.$root.$emit("hide-loading");
    }, 1500),
    finish() {
      this.$router.push({ name: "analise_cobertura.cobertura" });
    },
    async seeUnit(lab) {
      await this.SET_MATCH({ CodigoPrestador: lab.CodigoPrestador });
      this.$router.push({
        name: "affiliate.docInfo",
        params: {
          situacao: "A",
          rede: "0000",
          cdPrestador: lab.CodigoPrestador,
          srEndereco: lab.IdEndereco
        }
      });
    },
    labDistance(distance) {
      return distance + "km";
    }
  },
  async mounted() {
    const idSimulacao = Number(this.$route.query?.id);
    this.idSimulacao = idSimulacao;
    if (!idSimulacao) {
      this.$router.push({ name: "analise_cobertura.cobertura" });
      return;
    }

    this.$root.$emit("show-loading");
    await this.fetchBaseAddress({ type: "R" });
    await this.fetchLaboratoriess({ idSimulacao });
    this.$root.$emit("hide-loading");
  }
};
</script>
